// DEPRECATED: This file is being phased out
// Use the new structure: src/data/content.js and src/hooks/useContent.js
// This file is kept for backward compatibility during migration

import { content, socialData } from './content';
import { getSocialIcon } from './components';
import { useAPYContext, fillAPYRate } from "@/features/apy";
import DisclaimerText from '@/components/DisclaimerText';

// Process social data with icon components  
const processedSocialData = socialData.map(item => ({
  ...item,
  Icon: getSocialIcon(item.iconName)
}));

// Legacy data object - use useContent() hook instead
export const data = {
  ...content,
  socialData: processedSocialData,
  footer: {
    ...content.footer,
    disclaimer: <DisclaimerText />
  }
};

// Legacy function - use useContent() hook instead
export function useDataWithAPY() {
  const { apyRate } = useAPYContext();

  // Helper function to replace APY placeholders
  const replaceAPYPlaceholders = (text: string): string => {
    return fillAPYRate(text, apyRate);
  };

  return {
    ...data,
    benefitssection: {
      ...data.benefitssection,
      subheading: replaceAPYPlaceholders(data.benefitssection.subheading)
    },
    faqsection: {
      ...data.faqsection,
      list: data.faqsection.list.map(item => ({
        ...item,
        answer: replaceAPYPlaceholders(item.answer)
      }))
    },
    calltoaction: {
      ...data.calltoaction,
      list: data.calltoaction.list.map(item => replaceAPYPlaceholders(item))
    }
  };
}